import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../config/firebaseConfig";
import { Helmet } from "react-helmet-async";
import Pagination from "react-bootstrap/Pagination";

const Tasarimlarim = () => {
  const [designs, setDesigns] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Tümü");
  const designsPerPage = 9;

  useEffect(() => {
    const fetchDesigns = async () => {
      const galleryRef = collection(db, "gallery");
      const q = query(galleryRef, orderBy("createdAt", "desc"));
      const snapshot = await getDocs(q);
      const designList = snapshot.docs.map((doc) => doc.data());
      setDesigns(designList);
      
      const categoryList = ["Tümü", ...new Set(designList.map((design) => design.category))];
      setCategories(categoryList);
    };
    fetchDesigns();
  }, []);

  const filteredDesigns = selectedCategory === "Tümü" ? designs : designs.filter((design) => design.category === selectedCategory);
  
  const indexOfLastDesign = currentPage * designsPerPage;
  const indexOfFirstDesign = indexOfLastDesign - designsPerPage;
  const currentDesigns = filteredDesigns.slice(indexOfFirstDesign, indexOfLastDesign);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredDesigns.length / designsPerPage); i++) {
    pageNumbers.push(
      <Pagination.Item key={i} active={i === currentPage} onClick={() => paginate(i)}>
        {i}
      </Pagination.Item>
    );
  }

  const handleDownload = (url, title) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = title || "download";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section id="portfolio" className="portfolio section">
      <Helmet>
        <title>Afiş Tasarımlarım | Grafik Tasarım Portföyü</title>
        <link rel="canonical" href="https://hacialikara.com/tasarimlarim" />
        <meta name="description" content="Bu bölümde yaptığım afiş ve poster çalışmalarını sergiliyorum. Grafik tasarım becerilerimi ve projelerimi keşfetmek için portföyümü inceleyebilirsiniz." />
        <meta name="keywords" content="grafik tasarım, afiş tasarımı, poster tasarımı, portföy, görsel tasarım, web tasarım, yaratıcı projeler" />
        <meta property="og:title" content="Afiş Tasarımlarım | Grafik Tasarım Portföyü" />
        <meta property="og:description" content="Bu bölümde yaptığım afiş ve poster çalışmalarını sergiliyorum. Grafik tasarım becerilerimi ve projelerimi keşfetmek için portföyümü inceleyebilirsiniz." />
        <meta property="og:url" content="https://hacialikara.com/tasarimlarim" />
      </Helmet>

      <div className="container section-title text-center mb-4" data-aos="fade-up">
        <h2>Afiş Tasarımlarım</h2>
        <div className="title-shape">
          <svg viewBox="0 0 200 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M 0,10 C 40,0 60,20 100,10 C 140,0 160,20 200,10" fill="none" stroke="currentColor" strokeWidth="2"></path>
          </svg>
        </div>
        <p>Bu bölümde yaptığım afiş ve poster çalışmalarını sergiliyorum. Grafik tasarım becerilerimi ve projelerimi keşfetmek için portföyümü inceleyebilirsiniz.</p>
      </div>

      <div className="container mb-4">
        <div className="d-flex justify-content-center">
          {categories.map((category) => (
            <button key={category} className={`btn mx-2 ${selectedCategory === category ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setSelectedCategory(category)}>
              {category}
            </button>
          ))}
        </div>
      </div>

      <div className="container">
        <div className="row">
          {currentDesigns.map((design, index) => (
            <div key={index} className="col-md-4 mb-4 d-flex align-items-stretch">
              <div className="card w-100">
                <img src={design.imageUrl} alt={design.title} title={design.title} className="card-img-top" loading="lazy" onClick={() => setSelectedImage(design.imageUrl)} />
                <div className="card-body">
                  <h5 className="card-title">{design.title}</h5>
                  <p className="card-text">{design.description}</p>
                  <button className="btn btn-sm btn-outline-secondary mt-2" onClick={() => handleDownload(design.imageUrl, design.title)}>
                    İndir
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center mt-4">
          <Pagination>
            <Pagination.Prev onClick={() => setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev))} disabled={currentPage === 1} />
            {pageNumbers}
            <Pagination.Next onClick={() => setCurrentPage((prev) => (prev < pageNumbers.length ? prev + 1 : prev))} disabled={currentPage === pageNumbers.length} />
          </Pagination>
        </div>
      </div>

      {selectedImage && (
        <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close" onClick={() => setSelectedImage(null)}>&times;</span>
            <img src={selectedImage} alt="Seçili Afiş Tasarımı" className="modal-image" loading="lazy" />
          </div>
        </div>
      )}
    </section>
  );
};

export default Tasarimlarim;